import {select} from "../../../../../shared/SagaService";

export function* parseTerms(transaction) {
    const terms = yield select(state => state.List.terms);

    const invalidTerms = [];
    if (transaction.term_id && !terms.find(term => term.id === transaction.term_id)) {
        invalidTerms.push(transaction.autosave_text_values.term_id);
        // eslint-disable-next-line no-param-reassign
        transaction.term_id = null;
    }

    return invalidTerms;
}
